export const INBOX_RAIL_LAYOUT_STORAGE_KEY = "qwibInboxRailLayout";

export const INBOX_RAIL_LAYOUT = {
  merged: "merged",
  split: "split",
} as const;

export type InboxRailLayout = (typeof INBOX_RAIL_LAYOUT)[keyof typeof INBOX_RAIL_LAYOUT];

export const isInboxRailLayout = (value: string): value is InboxRailLayout =>
  value === INBOX_RAIL_LAYOUT.merged || value === INBOX_RAIL_LAYOUT.split;
